import {
    GET_CONTENT_BY_TAG_SUCCEEDED,
    SEARCH_ENTITY_IN_SITE_SUCCEEDED
} from '../actions/types';

const initialState = {
    resultsByTag: [],
    movies: [],
    articles: [],
    celebrities: [],
    movieTheaters: [],
    events: [],
    festivals: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CONTENT_BY_TAG_SUCCEEDED:
            return {
                ...state,
                resultsByTag: action.payload.rows
            };

        case SEARCH_ENTITY_IN_SITE_SUCCEEDED:
            return {
                ...state,
                movies: action.payload.movies,
                articles: action.payload.articles,
                celebrities: action.payload.celebrities,
                movieTheaters: action.payload.movieTheaters,
                events: action.payload.events,
                festivals: action.payload.festivals,
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/SHARED/reducers/searchresults.reducer.js